import { getAssessmentScoreLabel } from "@repo/app-types/constants/assessmentScore";
import { RadioButtonsGroup } from "@repo/ui/Buttons/radioButtonsGroup";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";

interface ScoreButtonGroupProps {
  score: number | undefined;
  onChange: (newScore: number) => void;
}

// TODO: Clean up this messy component.
export const ScoreButtonGroup: FC<ScoreButtonGroupProps> = ({
  score,
  onChange,
}) => {
  // Built-in score options
  const options = [
    { score: 5, text: getAssessmentScoreLabel(5) },
    { score: 4, text: getAssessmentScoreLabel(4) },
    { score: 3, text: getAssessmentScoreLabel(3) },
    { score: 2, text: getAssessmentScoreLabel(2) },
    { score: 1, text: getAssessmentScoreLabel(1) },
  ];

  // Transform our score options to the format expected by RadioButtonsGroup
  const radioOptions = options.map((option) => ({
    name: `${option.score} - ${option.text}`,
    // We could add a description here if needed
  }));

  // Convert numeric score to string format that RadioButtonsGroup expects
  const value = score
    ? `${score} - ${options.find((o) => o.score === score)?.text}`
    : null;

  const handleChange = (newValue: string) => {
    // Extract score from the option string (eg. "5 - Excellent" -> 5)
    const newScore = Number(newValue.split(" - ")[0]);
    onChange(newScore);
  };

  return (
    <RadioButtonsGroup
      options={radioOptions}
      value={value}
      onChange={handleChange}
      size={Size.MEDIUM}
    />
  );
};
